import React from 'react';
import { NavLink } from 'react-router-dom';
import config from "../../Config";
import { useState, useEffect } from "react";


function Footer(props) {
    const [baseURL, setBaseURL] = useState(config.base_url);
    
    const FYear = localStorage.getItem("DefaultFYear");


    return (
        <>
            <footer>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            &copy; 2023 - All Rights Reserved.
                        </div>
                        <div className="col-md-3">
                            {baseURL}
                        </div>

                        <div className="col-md-3 text-center">
                            Current working year is <NavLink to="/Accounts/ChangeYear"><strong>{FYear}</strong></NavLink>
                        </div>


                        <div className="col-md-3 text-md-end">
                            Powered by: MaimaSoft.com
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;